"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropDownItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Radio = require("../radio/Radio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      background: 'none',
      color: theme.palette.text.primary,
      height: 24,
      marginRight: 16,
      width: 24
    },
    dpItem: {
      height: 36,
      padding: 16,
      width: '100%',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    dpItemDisabled: {
      backgroundColor: theme.palette.action.disabled,
      cursor: 'auto',
      '&:hover': {
        backgroundColor: theme.palette.action.disabled
      }
    },
    dpItemNested: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    checkbox: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: 'rgba(98, 76, 146, .08)'
      }
    },
    periferics: {
      background: 'none',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    subMenu: {
      pointerEvents: 'auto'
    }
  };
});

var DropDownItem = function DropDownItem(_ref) {
  var text = _ref.text,
      disabled = _ref.disabled,
      icon = _ref.icon,
      radio = _ref.radio,
      checkbox = _ref.checkbox,
      cascaded = _ref.cascaded,
      children = _ref.children,
      onClick = _ref.onClick;
  var classes = useStyles();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      subAnchorEl = _useState2[0],
      setSubAnchorEl = _useState2[1];

  var isSubMenuOpen = Boolean(Boolean(subAnchorEl));

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isChecked = _useState4[0],
      setIsChecked = _useState4[1];

  var handleMouseEnter = function handleMouseEnter(event) {
    setSubAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setSubAnchorEl(null);
  };

  var handleCheck = function handleCheck() {
    setIsChecked(!isChecked);
  };

  if (cascaded) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: text,
    className: disabled ? "".concat(classes.dpItem, " ").concat(classes.dpItemNested, " ").concat(classes.dpItemDisabled) : "".concat(classes.dpItem, " ").concat(classes.dpItemNested),
    disableRipple: true,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleClose
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, text), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    style: {
      pointerEvents: 'none'
    },
    anchorEl: subAnchorEl,
    open: isSubMenuOpen,
    getContentAnchorEl: null,
    classes: {
      paper: classes.subMenu
    },
    anchorOrigin: {
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      elevation: 4
    }
  }, children)));
  if (radio || checkbox) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: "".concat(classes.dpItem, " ").concat(classes.periferics),
    disabled: disabled,
    onClick: onClick
  }, checkbox && !radio && /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      disabled: disabled,
      checked: isChecked,
      onChange: handleCheck,
      name: "checked",
      className: classes.checkbox,
      icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, {
        className: disabled ? null : classes.checkbox
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: disabled ? classes.checkboxDisabled : classes.checkbox
      })
    }),
    label: text,
    value: text
  }), radio && !checkbox && /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    value: text,
    control: /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
      disabled: disabled
    }),
    label: text
  }));
  return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: disabled ? "".concat(classes.dpItem, " ").concat(classes.dpItemDisabled) : classes.dpItem,
    disabled: disabled,
    onClick: onClick
  }, icon && /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    icon: icon
  }, icon), !checkbox && !radio || checkbox && radio ? text : null);
};

exports.DropDownItem = DropDownItem;
DropDownItem.propTypes = {
  /**
   * Escolhe o texto do item
   */
  text: _propTypes.default.node,

  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,

  /**
   * Se `true` o campo é um checkbox
   */
  checkbox: _propTypes.default.bool,

  /**
   * Se `true` o campo é um radio button
   */
  radio: _propTypes.default.bool,

  /**
   * Se `true` o campo é cascaded
   */
  cascaded: _propTypes.default.bool,

  /**
   * Preencha para adicionar o source do ícone
   */
  icon: _propTypes.default.node,

  /**
   * o que será colocado no cascade
   */
  children: _propTypes.default.node,

  /**
   * Função que será executada quando o botão for clicado
   */
  onClick: _propTypes.default.func.isRequired
};
DropDownItem.defaultProps = {
  text: 'Item example',
  disabled: false,
  cascaded: false,
  checkbox: false,
  radio: false,
  icon: null,
  children: null
};
var _default = DropDownItem;
exports.default = _default;